var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 70,
    viewBox: "0 0 180 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2991",
    "data-name": "Rectangle 2991",
    width: 180,
    height: 70,
    transform: "translate(270)",
    fill: "#aa4545"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4209",
    "data-name": "Group 4209",
    transform: "translate(-270)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7827",
    "data-name": "Group 7827",
    transform: "matrix(-0.999, -0.052, 0.052, -0.999, -611.927, -685.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7827-2",
    "data-name": "Group 7827",
    transform: "translate(-1094 -716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9564",
    "data-name": "Path 9564",
    d: "M878.807,944.289c-2.574,4.373-3.761,9.468-6.469,13.76-7.332,11.62-23.02,14-36.738,14.775s-29.2,1.918-37.991,12.479c-2.775,3.335-4.717,7.478-8.263,9.979a20.087,20.087,0,0,1-8.215,2.974c-11.8,2.072-24.076.234-35.8,2.705s-23.7,11.623-23.045,23.59c.578,10.611,10.719,18.219,20.786,21.623a62.594,62.594,0,0,0,19.982,3.291c27.494.011,51.695-17.722,78.512-23.784,12.263-2.772,24.928-3.062,37.45-4.191s25.247-3.2,36.322-9.147,20.358-16.4,22.1-28.851c1.352-9.664-1.929-18.929-5.867-27.593-3.109-6.841-6.769-19.965-12.2-25.068C909.193,921.266,884.568,934.5,878.807,944.289Z",
    transform: "translate(-722.258 -919.968)",
    fill: "#239281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9565",
    "data-name": "Path 9565",
    d: "M955.463,859.72c-7.492,13.463-11.869,30.71-25.886,37.1-10.04,4.579-21.678,1.81-32.587.144s-23.713-1.454-30.874,6.942c-2.932,3.438-4.6,7.964-8.126,10.784-5.7,4.556-13.883,3.1-21.172,2.747a60.365,60.365,0,0,0-49.457,22.477,8.154,8.154,0,0,0-2.074,4.18c-.276,3.33,3.133,5.7,6.229,6.958,11.434,4.639,24.294,4.354,36.475,2.379s24.066-5.556,36.279-7.32c29.11-4.2,59.916,1.884,87.441-8.48a77.933,77.933,0,0,0,43.507-41.446c7.147-16.506,10.924-44.971,0-60.987C984.587,819.605,960.609,850.474,955.463,859.72Z",
    transform: "translate(-780.347 -830.872)",
    fill: "#1d3943"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideIcon);
export default __webpack_public_path__ + "static/media/side_icon.bd6a7f50bcd711c5da24ac145ea39ac9.svg";
export { ForwardRef as ReactComponent };